import { FooterLink, FooterLink14 } from "./footer-link";
import { Form } from './form';
import { FormItem } from './form-item';

export const classes = {
    FooterLink,
    FooterLink14,
    Form,
    FormItem
}